export default __webpack_public_path__ + "static/media/cs_icon_06.4a12dc7b.png";